import { cn } from '@workspace/ui/lib/utils'
import * as React from 'react'

export interface ProfileSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Section title */
  title?: string
  /** Optional action buttons/links for the section header */
  actions?: React.ReactNode
  /** Children content */
  children: React.ReactNode
}

export const ProfileSection = React.forwardRef<HTMLDivElement, ProfileSectionProps>(
  ({ title, actions, children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('space-y-3', className)} {...props}>
        {(title || actions) && (
          <div className="flex items-center justify-between">
            {title && (
              <h2 className="px-1 text-sm font-medium text-muted-foreground uppercase tracking-wider">
                {title}
              </h2>
            )}
            {actions && <div className="flex items-center gap-2">{actions}</div>}
          </div>
        )}
        {children}
      </div>
    )
  }
)

ProfileSection.displayName = 'ProfileSection'
